import { Card } from '@arkestro/arkestro-design-system';
import { Radio } from 'antd';
import { WithTruncatedTooltip } from '@components/shared/WithTruncatedTooltip';
import styles from './CompanyCard.module.scss';

interface Props {
  company: any;
  dataTestId: string;
  onClick: () => void;
  selectedVendorOrg: number;
}
export const CompanyCard = ({ company, dataTestId, onClick, selectedVendorOrg }: Props) => {
  return (
    <Card
      className={styles.companyCard}
      data-testid={dataTestId}
      hoverable
      onClick={onClick}
    >
      <Radio className={styles.companyRadio} value={selectedVendorOrg}>
        <div className={styles.companyInfo} >
          <WithTruncatedTooltip name={company.name} style={styles.companyName} />
          { company.website && <WithTruncatedTooltip name={company.website} style={styles.companyWebsite} /> }
        </div>
      </Radio>
    </Card>
  );
};
